module.exports = __webpack_public_path__ + "static/media/cert_AUA_UD_Elf.127e8c9d.jpg";